import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

const JobNotebookEmpty = ({ onStart }) => (
  <Box
    style={{
      height: 'calc(100% - 2px)',
      marginLeft: '3px',
      overflowX: 'hidden',
      overflowY: 'hidden',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <Box style={{ textAlign: 'center' }}>
      <Button variant="contained" type="primary" onClick={onStart}>
        Start the Notebook
      </Button>
    </Box>
  </Box>
);

export default JobNotebookEmpty;
